/* eslint-disable import/prefer-default-export */
import { withPreloadedJSON } from "@wss/hypernova";
import BlogFooter from "./BlogFooter";
export const BlogFooterWithData = withPreloadedJSON(BlogFooter, "BlogFooter");